import * as angular from "angular";
import {IController, IScope} from "angular";
import {$agentFactory} from "../../$agent.factory";
import {SplitService} from "../../../commons/services/split-service.service";
import {GpsPermissionType} from "../../types/gps-permission.type";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {AgentAuthType} from "../../types/agentAuth.type";
import {AgentStatusType} from "../../types/agentStatus.type";

export class AgentsRadioTableRowCtrl implements IController {

  agent: string;
  isSelected: any;
  onSelect: Function;

  public isSmallScreen: boolean;
  public isAgentAssistantEnabled: any;
  public filterAgentsByGpsEnabled: boolean;
  public agentAuthType: typeof AgentAuthType = AgentAuthType;
  public agentTeamNames: string[];

  constructor(private $mdMedia) {
  }

  $onInit() {

  }

  $onChanges(changes) {
    if (changes.agentId && !changes.agentId.isFirstChange()) {
      this.$onInit();
    }
  }

  $doCheck() {
    this.isSmallScreen = !this.$mdMedia('gt-md');
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsRadioTableRow', {
    require: {
      agentsTableCtrl: '^agentsRadioTable'
    },
    bindings: {
      agent: '<',
      isSelected: '<?',
      onSelect: '&'
    },
    template: require('./agents-radio-table-row.html').default,
    controller: AgentsRadioTableRowCtrl
  });
